export default __webpack_public_path__ + "46e5e48ed778e71b1395ab9e0dd0ea29.png";